export default __webpack_public_path__ + "static/media/37_4_0.9f768a4e.png";